import { render, staticRenderFns } from "./AiCompatibilityNotice.vue?vue&type=template&id=17c39ba3&scoped=true&"
import script from "./AiCompatibilityNotice.vue?vue&type=script&lang=js&"
export * from "./AiCompatibilityNotice.vue?vue&type=script&lang=js&"
import style0 from "./AiCompatibilityNotice.vue?vue&type=style&index=0&id=17c39ba3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17c39ba3",
  null
  
)

export default component.exports